module.exports = __webpack_public_path__ + "img/horizontal_6_3_6000.b990b8c6.png";